<template>
    <div>
        <v-dialog v-model="show" max-width="580" @click:outside="$emit('closeDialog')">
            <v-card tile elevation="0">
                <v-card-title class="dialog-container--header" :style="layout == 'portal' ? 'background: linear-gradient(90deg, #BFE5E8 0%, #EFDDD1 100%);' : 'background: var(--v-primary-opacity-12)'">
                    <v-icon color="primary" size="28">{{icon}}</v-icon>
                    <span class="dialog-container--header--text">{{title}}</span> 
                    <v-btn
                        class="mx-2"
                        style="right: 0"
                        elevation="0"
                        fab
                        absolute
                        small
                        color="transparent"
                    >
                        <v-icon  
                            color="primary"
                            @click="$emit('closeDialog')"
                        >
                            fxt-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="dialog-container--content-text" :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 75%'">
                    <slot class="pa-0 pt-5" style="">Ingen innhold</slot>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn 
                        class="text-none px-4" 
                        color="primary" 
                        rounded 
                        text
                        elevation="0"
                        @click="$emit('closeDialog')"
                        v-if="!(hideActions || buttonTextCancel == '')"
                    >
                        <span class="font-weight-bold">{{buttonTextCancel}}</span>
                    </v-btn>
                    <v-btn 
                        class="text-none px-4" 
                        :color="buttonColorConfirm"
                        :style="'color:' + buttonTextColorConfirm"
                        rounded
                        elevation="0"
                        @click="$emit('confirmAction')"
                        v-if="!(hideActions || buttonTextConfirm == '')"
                    >
                        <div class="d-flex ">
                            <div>{{buttonTextConfirm}}</div>
                            <v-icon class="pl-2" size="22" v-if="buttonIconConfirm">{{buttonIconConfirm}}</v-icon>
                        </div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            required: true,
            default: false,
            type: Boolean
        },
        icon: {
            required: false,
            default: '',
            type: String
        },
        title: {
            required: false,
            default: '',
            type: String
        },
        buttonTextConfirm: {
            required: false,
            default: '',
            type: String
        },
        buttonIconConfirm: {
            required: false,
            default: '',
            type: String
        },
        buttonColorConfirm: {
            required: false,
            default: 'primary',
            type: String
        },
        buttonTextColorConfirm: {
            required: false,
            default: 'var(--v-primary-text-base)',
            type: String
        },
        buttonTextCancel: {
            required: false,
            default: '',
            type: String
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        },
        hideActions: {
            required: false,
            default: false,
            type: Boolean
        }
    },
}
</script>

<style lang="scss">
    .dialog-container {
        &--header {
            color: var(--v-primary-base);
            flex-wrap: nowrap;
            padding: 16px !important;
            &--text {
                max-width: 80%;
                font-weight: 700;
                font-size: 17px;
                line-height: 28px;
                padding-left: 8px;
                overflow: hidden;
                word-break: normal;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }
        &--content-text {
            color: #222222 !important;
            padding-top: 20px !important;
            padding-bottom: 0px !important;
            margin: 0 auto;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
        }
    }
</style>